<template>
  <v-app id="keep">
    <v-layout wrap>
      <v-app-bar
        id="header_style"
        v-if="inited && !login"
        app
        clipped-left
        color="primary"
      >
        <v-flex xs3>
          <!-- https://codepen.io/pen/?&editors=101 -->
          <v-layout justify-start align-center>
            <v-app-bar-nav-icon
              class="hamburger_icon"
              @click="drawer = !drawer"
            />
            <div
              class="pa-2 white--text"
              v-if="showLeftToolbarItems"
              @click="toCalendar"
            >
              Календар
            </div>
            <div
              class="pa-2 white--text"
              v-if="showLeftToolbarItems"
              @click="toLibrary"
            >
              Бібліотека
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs7>
          <v-layout justify-center align-center>
            <div
              class="title logo_small"
              :class="{
                'small-screen': $vuetify.breakpoint.xsOnly,
              }"
            >
              RedFox Homeschool&nbsp;
            </div>
          </v-layout>
        </v-flex>
        <v-flex xs2>
          <v-layout justify-end align-center wrap>
            <div
              class="pa-2 white--text"
              v-if="!isGuest && $vuetify.breakpoint.lgAndUp"
            >
              {{ user.firstName }} {{ user.lastName }}
              <span v-if="user.grade">{{ user.grade }}-й клас</span>
            </div>
            <div
              class="pa-2 white--text"
              v-else-if="$vuetify.breakpoint.lgOnly"
            >
              Демо
            </div>
            <div class="pa-2" @click="logout">
              <v-icon color="white" v-html="'$vuetify.icons.logout'"></v-icon>
            </div>
          </v-layout>
        </v-flex>
      </v-app-bar>

      <v-navigation-drawer
        v-if="inited && !login"
        v-model="drawer"
        app
        clipped
        color="secondary"
      >
        <v-list dense color="secondary">
          <CourseItem
            :small-screen="!showLeftToolbarItems"
            @courseItemsEvent="courseItemsEventHandler"
          />
        </v-list>
      </v-navigation-drawer>

      <component
        :is="currentPopup"
        :popupContext="currentPopupContext"
        @popupEvent="popupEventHandler"
      ></component>
      <router-view v-if="inited" />
    </v-layout>
  </v-app>
</template>

<script>
import RestService from "@/services/RestService";
import GoogleAnaliticService from "@/services/GoogleAnaliticService";
import CourseItem from "@/components/Pages/ClassPage/CourseItem";
import appName from "@/enums/appName";
import statesEnum from "@/enums/statesEnum";
import popupEnum from "@/enums/popupEnum";
import PopupEventEnum from "@/enums/PopupEventEnum";

import appMixin from "@/components/Mixin/appMixin";

export default {
  name: "App",
  components: { CourseItem },
  mixins: [appMixin],
  data() {
    return {
      currentPopup: null,
      currentPopupContext: {},
      inited: false,
      urlParams: {},
      drawer: true,
      color: "primary",
      colors: ["primary", "blue", "success", "red", "teal"],
      right: false,
      permanent: true,
      miniVariant: false,
      expandOnHover: false,
      background: false,
      headers: [
        {
          text: "Lessons",
          align: "start",
          sortable: false,
          value: "name",
          filter: false,
        },
      ],
    };
  },
  computed: {
    showLeftToolbarItems() {
      return (
        this.isStudentApp &&
        !this.$vuetify.breakpoint.xsOnly &&
        !this.$vuetify.breakpoint.smOnly
      );
    },
    isStudentApp() {
      return this.$store.getters["ConfigStore/isStudentApp"];
    },
    isTeacherApp() {
      return this.$store.getters["ConfigStore/isTeacherApp"];
    },
    isGuest() {
      return this.$store.getters["UserStore/isGuest"]();
    },
    lessons() {
      return this.$store.getters["LessonsStore/getLessons"];
    },
    user() {
      return this.$store.getters["UserStore/getUser"];
    },
    route() {
      return this.$route;
    },
    stateName() {
      return this.$store.getters["ConfigStore/getCurrentState"];
    },
    login() {
      const authorizedPages = this.$store.getters[
        "ConfigStore/getAuthorizedPages"
      ];
      return authorizedPages.includes(this.stateName);
    },
  },
  watch: {
    route(newRoute, oldRoute) {
      return this.$store.dispatch("ConfigStore/updateRoute", {
        from: oldRoute,
        to: newRoute,
      });
    },
  },
  async created() {
    this.urlParams = this.parseUrls();

    const initConfig = {
      appName: appName.STUDENT_APP,
      demoToken: this.urlParams.demoToken,
    };
    await this.$store.dispatch("ConfigStore/createConfigs", initConfig);
    const configView = this.$store.getters["ConfigStore/getConfigView"];
    this.$store.dispatch("ConfigStore/updateRoute", {
      from: {},
      to: this.route,
    });
    this.initServices(configView);
    this.subscribe();
    this.afterLogin();
    if (this.user) {
      this.$store.dispatch("UserActivityStore/initStore");
    }
    this.inited = true;
    GoogleAnaliticService.trackUserAction(this.$store, "loadApp");
  },
  methods: {
    subscribe() {
      this.$store.subscribeAction({
        after: async (action, state) => {
          switch (action.type) {
            case "PopupStore/openPopup":
              this.openPopup(action.payload);
              break;
            default:
              break;
          }
        },
      });
    },
    openPopup(payload) {
      const { popupName } = payload;
      this.currentPopup = this.$store.getters["PopupStore/getPopup"](popupName);
      this.currentPopupContext = this.$store.getters[
        "PopupStore/getPopupContext"
      ](popupName);
    },
    popupEventHandler(payload) {
      const { type } = payload;
      switch (type) {
        case PopupEventEnum.CLOSE_POPUP:
          this.currentPopup = null;
          break;

        default:
          break;
      }
    },
    parseUrls() {
      const urlParams = new URLSearchParams(window.location.search);
      const rawDemoToken = urlParams.get("demoToken") || "";
      // 'http://18.216.218.57/school/#/login/?demoToken=3422f64fa0f206caee5af107650c5f92588ed3f0'
      let demoToken = "";
      if (rawDemoToken.length === 40) {
        demoToken = rawDemoToken;
      }
      return { demoToken };
    },
    initServices(configView) {
      RestService.init(configView);
      GoogleAnaliticService.installAnalitic(this.$store);
    },
    courseItemsEventHandler: function () {},

    logout() {
      if (this.isGuest) {
        const redirectUrl = this.$store.getters[
          "ConfigStore/getRedirectLandingUrl"
        ];
        this.$_logout();
        window.location.href = redirectUrl;
        return;
      }
      this.$_logout();
    },
    $_logout() {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("rawUser");
      this.$store.dispatch("ConfigStore/removeDemoToken");
      this.$store.dispatch("UserStore/logout");
      this.$store.dispatch("UserActivityStore/stopLesson");
      this.$router.push({ name: statesEnum.LOGIN });
    },
    toLibrary() {
      this.$router.push({ name: statesEnum.LIBRARY });
    },
    toCalendar() {
      this.$router.push({ name: statesEnum.CALENDAR });
    },
  },
};
</script>
<style>
@import "./style/myStyle.css";
</style>
